import $ from './main';

/**
 * print error message
 * @param error
 */
const printErrorForField = (error) => {
  // 1. find the field that the error relates too?
  const $field = $(`.field.js-f2c-${error.id}`);
  if ($field.length) {
    $field.append(`<ul class="validationErrors"><li class="formValidationError">${error.message}</li></ul>`);
  }
};

/**
 * wham in the errors
 * @param errors
 */
const errorHandler = (errors) => {
  $('body').removeClass('submitting');
  errors.forEach(printErrorForField);
};

/**
 * if we have a token, we can now submit and do the actual payment
 *
 * @param e
 */
const tokeniseHander = (e) => {
  console.debug('f2c tokeniseHander:', e);

  // we have a token, so set it in the hidden field
  $('#f2c-token')
    .val(e.token);

  // Now that we have the token, trigger the form submission
  console.log("resume submission");
  $('#f2c-form button[type="submit"]')
    .click();


};

const changeHandler = (e) => {
  console.debug('f2c changeHandler:', e);
  const $field = $(`#f2c-${e.id}`);
  if (e.type === 'blur') {
    $field.removeClass('input--txt--focused');
  }

  if (e.type === 'focus') {
    $field.addClass('input--txt--focused');
  }
};

/**
 * configure the form
 * @param token
 * @param isSandbox
 */
const initForm = ({ token, isSandbox }) => {
  console.debug('f2c initForm:', { token, isSandbox });

  const Flo2Cash = window.Flo2Cash || {};
  
  // Initialize Flo2Cash first
  Flo2Cash.initialise(
    token,
    {
      id: 'f2c-form',
      tokenField: 'f2c-token',
      mode: isSandbox ? 'sandbox' : 'prod',
      inputFields: {
        number: {
          id: 'f2c-number',
          style: 'width: 100%; height: 100% ; color: #2F3336; background-color: transparent; padding: 1rem; margin-left: -1rem; margin-top:-1rem; font-size: 16.95px;',
        },
        cvv: {
          id: 'f2c-cvv',
          placeholder: '',
          style: 'width: 100%; height: 100% ; color: #2F3336; background-color: transparent; padding: 1rem; margin-left: -1rem; margin-top:-1rem; font-size: 16.95px;',
        },
        expiryDate: {
          id: 'f2c-expiry-month',
          'placeholder-month': 'MM',
          'placeholder-year': 'YY',
          style: 'width: 100%; height: 100% ; color: #2F3336; background-color: transparent; padding: 1rem; margin-left: -1rem; margin-top:-1rem; font-size: 16.95px; background-color: #f5f5f5; ',
        },
        nameOnCard: {
          id: 'f2c-name',
          placeholder: '',
          style: 'width: 100%; height: 100% ; color: #2F3336; background-color: transparent; padding: 1rem; margin-left: -1rem; margin-top:-1rem; font-size: 16.95px;',
        },
      },
    },
    (errors) => {
      // initialisation errors
      if (errors) {
        console.error('Flo2Cash initialization errors:', errors);
      } else {
        // Only set the token after successful initialization
        $('#f2c-token').val(token);
      }
    },
  );
  
  // Register event handlers
  Flo2Cash.register('onTokenisation', tokeniseHander);
  Flo2Cash.register('onError', errorHandler);
  Flo2Cash.register('onFieldChange', changeHandler);
};

/**
 * jam in the javascript and get it loaded
 * @param endPoint
 * @param token
 * @param isSandbox
 */
const injectIframe = ({ endPoint, token, isSandbox }) => {
  console.debug('f2c injectIframe:', { endPoint, token, isSandbox });

  const script = document.createElement('script');
  script.async = true;
  script.src = endPoint;
  script.addEventListener('load', () => {
    initForm({ token, isSandbox });
  });

  document.head.appendChild(script);
};

/**
 * handle the on submit, grab a token we can use to process the transaction
 * @param ev
 */
const submitPaymentForm = (ev) => {
  console.debug('f2c submitPaymentForm:', ev);

  // we need to disabled button so no one can submit twice
  $('body').addClass('submit');
  $('.js-donate-disable-first-click').attr("disabled", true);

  // if we have no token, then we do the get token first...
  // otherwise we submit the form
  const token = $('#f2c-token').val();
  if (!token) {
    // if validation error we need to remove disabled and loading
    $('body').removeClass('submit');

    $('.js-donate-disable-first-click').attr("disabled", false);

    if (window.existingRecaptcha.f2crecaptcha !== undefined) {
      const r = grecaptcha.getResponse(window.existingRecaptcha.f2crecaptcha);
      if (!r) {
        return false;
      }
    }
    
    ev.preventDefault();
    $('.validationErrors').remove();
    $('body').addClass('submitting');
    
    // Get the Flo2Cash instance
    const Flo2Cash = window.Flo2Cash;
    if (!Flo2Cash) {
      console.error('Flo2Cash is not initialized');
      return false;
    }
    
    // Request token
    Flo2Cash.getToken();
    return false;
  }

  // If we have a token, let HTMX handle the submission
  return true;
};

/**
 * bridge in the focus event to the iframe.. ugh
 * @param ev
 */
const focusField = (ev) => {
  const field = ev.currentTarget.querySelector('.js-f2c-field');
  if (field) {
    const Flo2Cash = window.Flo2Cash || {};
    Flo2Cash.setFocus(field.id.replace('f2c-', ''));
  }
};

const beforeRequest = (evt) => {
  console.debug('f2c beforeRequest:', evt);
  // Disable the submit button
  $('.js-donate-disable-first-click')
    .attr("disabled", true);

  $('body')
    .addClass('submitting');

  // Check if we have a token
  const token = $('#f2c-token').val();
  if (!token) {
    // Prevent the HTMX request
    evt.preventDefault();
    
    // Check reCAPTCHA if needed
    if (window.existingRecaptcha.f2crecaptcha !== undefined) {
      const r = grecaptcha.getResponse(window.existingRecaptcha.f2crecaptcha);
      if (!r) {
        $('body').removeClass('submitting');
        $('.js-donate-disable-first-click').attr("disabled", false);
        return;
      }
    }
    
    // Clear any existing validation errors
    $('.validationErrors').remove();
    
    // Get the Flo2Cash instance
    const Flo2Cash = window.Flo2Cash;
    if (!Flo2Cash) {
      console.error('Flo2Cash is not initialized');
      $('body')
        .removeClass('submitting');

      $('.js-donate-disable-first-click')
        .attr("disabled", false);
      return;
    }
    
    // Request token
    Flo2Cash.getToken();
  }
}

const afterRequest = (evt) => {
  console.debug('f2c afterRequest:', evt);
  // Re-enable the submit button
  $('.js-donate-disable-first-click')
    .attr("disabled", false);

  $('body')
    .removeClass('submitting');
}

$(document).ready(($) => {
  console.debug('ready:');
  if (window.iframeprops) {
    injectIframe(window.iframeprops);
  }
  
  const $form = $('#f2c-form');
  
  // Add HTMX event handlers scoped to the payment form
  if(window.inlineDonation) {
    $form.on('htmx:beforeRequest', function(evt) {
      beforeRequest(evt);
    });

    $form.on('htmx:afterRequest', function(evt) {
      afterRequest(evt);
    });
  } else {
    $form.on('submit', submitPaymentForm);
  }

  $form.on('click', '.field', focusField);
});

